import React from "react";
import style from "./index.module.scss";
import { Button, Divider, message, Tooltip } from "antd";
import moment from "moment";
import Status from "./components/Status";
import useDeviceType from "Utils/useDeviceType";
import { ExperiListItem, goToExperimentUrl } from "API/experiment";

interface ListItemProps {
    data: ExperiListItem;
    onChange: () => void;
}

export default function ListItem({ data }: ListItemProps) {
    const { isMobile } = useDeviceType();

    function gotoExperiment(url: string) {
        if (data.useStatus !== "1") {
            message.error("尚未到达预约实验的开始时间");
        } else {
            goToExperimentUrl(url);
        }
    }

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Tooltip title={data.name}>{data.name}</Tooltip>
                {!isMobile && <Status status={parseInt(data.useStatus)} />}
            </h1>

            {isMobile && (
                <div>
                    <Status status={parseInt(data.useStatus)} />
                </div>
            )}

            <div className={style.info}>
                实验项目 {data.projectName}
                <Divider type="vertical" style={{ background: "#aaa" }} />
                预约数量 {data.useCount}
                {!isMobile && (
                    <Divider type="vertical" style={{ background: "#aaa" }} />
                )}
                <span>
                    实验时间 {moment(data.beginTime).format("MM-DD HH:mm")} ~{" "}
                    {moment(data.endTime).format("MM-DD HH:mm")}
                </span>
            </div>

            {/*0:未开始， 1:进行中， 2:已结束*/}
            {!isMobile && (
                <div className={style.tools}>
                    {data.useStatus !== "2" && (
                        <Button
                            type="link"
                            onClick={() => gotoExperiment(data.url)}
                            role="button">
                            前往实验
                        </Button>
                    )}
                </div>
            )}

            {isMobile && data.useStatus !== "2" && (
                <div className={style.footer}>请使用电脑进行实验</div>
            )}
        </div>
    );
}
